import React from "react";

import "./GreetingCard.scss";

export default function GreetingCard() {
  return (
    <div className="greeting_card custom_card">
      <h4>Welcome, Anish Shrestha</h4>
      <p>Let's guide you through your learning process</p>
    </div>
  );
}
